<template>
    <div>
        <Toolbar>
            <BackButton :to="__('general.integrations')"
                        :href="$route('integrations.admin.overview')"
            />
        </Toolbar>

        <Card>
            <template v-slot:icon>
                <img v-if="integration.icon_url"
                     :src="integration.icon_url"
                     :alt="integration.code"
                     class="h-1em"
                >
            </template>
            <template v-slot:title>
                {{ integration.name }} Users
            </template>

            <Table>
                <template v-slot:headers>
                    <th>UID</th>
                    <th>Name</th>
                    <th>E-Mail</th>
                    <th class="text-center">Active Stores</th>
                </template>

                <tr v-for="user in users">
                    <td>{{ user.firebase_uid }}</td>
                    <td>{{ user.name }}</td>
                    <td>{{ user.email }}</td>
                    <td class="text-center" :class="{'font-weight-bold': user.stores_count}">
                        {{ user.stores_count }}
                    </td>
                </tr>
            </Table>
        </Card>
    </div>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import Table from "@components/Table/Table.vue";
import BackButton from "@components/BackButton.vue";
import Toolbar from "@components/Toolbar.vue";

export default {
    components: {Toolbar, BackButton, Card, Table},

    props: {
        integration: Object,
        users: Array
    }
}
</script>
